<template>
  <div id="app">
    <img src="./assets/logo.png">

    <HelloWorld />
    <div class="hello">
      <h1>Random Fact:</h1>
      <button @click="fetchData">Click Me!</button>
      <p v-if="fact">{{ fact }}</p>
    </div>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data() {
    return {
      fact: "",
    };
  },
  methods: {
    fetchData() {
      fetch('https://llmap-jb3fv55vna-as.a.run.app', {
        method: "GET",
        headers: {
          "access-control-allow-origin": '*'
          // "X-RapidAPI-Key": 'your-api-key',
          // "X-RapidAPI-Host": 'facts-by-api-ninjas.p.rapidapi.com',
        },
      })
        .then((response) => {
          response.json().then((data) => {
            this.fact = data[0].fact;

            console.log(data);
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
}

</script>



<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

button {
  padding: 12px 32px;
  font-size: 16px;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue